import { requestWithToken as request } from "./api";

export const getFintocToken = (data) =>
    request.post("/fintoc_app/company_account_link/?format=json", data);

export const disconnectAccountLink = (id = Number) =>
    request.delete(`/fintoc_app/company_account_link/${id}/`);

export const saveFintocUserHolder = async (data) =>
    await request.post("/fintoc_app/link_account", data);

export const updateObligationsFintoc = (data) =>
    request.post("/fintoc_app/update_all_movements/?format=json", data);

export const loadLogs = (rutCompany, product) =>
    request.get(`/analyst_view/${rutCompany}/fintoc_logs?product=${product}`);